/**
 * The three run statuses of the sync and description dashboards, with one set of labels. Both ESB
 * modules use the same values, so a shared map keeps the wording identical and gives compile-time
 * cover when a status is ever added.
 */
export type RunStatus = "RUNNING" | "SUCCESS" | "FAILED";

export const RUN_STATUS_LABEL_KEY: Record<RunStatus, string> = {
  RUNNING: "runStatus.running",
  SUCCESS: "runStatus.success",
  FAILED: "runStatus.failed"
};
